import React, { SVGProps } from "react"

export const RefreshCCWIcon: React.FC<SVGProps<SVGSVGElement>> = props => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      className="stroke-fg-1"
      {...props}>
      <path
        d="M1.66602 8.33333C1.66602 8.33333 3.33683 6.05685 4.69421 4.69854C6.05159 3.34022 7.92735 2.5 9.99935 2.5C14.1415 2.5 17.4993 5.85786 17.4993 10C17.4993 14.1421 14.1415 17.5 9.99935 17.5C6.5801 17.5 3.69527 15.2119 2.79249 12.0833M1.66602 8.33333V3.33333M1.66602 8.33333H6.66602"
        stroke="#757575"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}
